import { IconNames } from '@icon/assets';

export interface HeaderItem {
	iconName: IconNames;
	iconClass?: string;
	eventId: string;
	ariaLabel?: string;
	reloading?: boolean;
}

export interface HeaderSymbol {
	name: string;
	groupId?: number;
}

/**
 * Event name: 'header.configuration'
 * Features publish this to control header appearance.
 *
 * In RTL: headerRightSectionItems sit with logo/title (visual right),
 * headerLeftSectionItems sit opposite (visual left).
 */
export interface HeaderConfigurationEvent {
	/**
	 * Off for screens that carry their own top section instead of the app bar —
	 * the سایر page opens on its profile card, per the handoff.
	 */
	visible?: boolean;
	showLogo?: boolean;
	showClock?: boolean;
	title?: string;
	symbol?: HeaderSymbol | null;
	headerRightSectionItems?: HeaderItem[];
	headerLeftSectionItems?: HeaderItem[];
}

/**
 * Event name: 'header.action'
 * Header publishes this when the user interacts with header controls.
 */
export interface HeaderActionEvent {
	eventId: string;
}

export const DEFAULT_HEADER_CONFIGURATION: Required<HeaderConfigurationEvent> = {
	visible: true,
	showLogo: true,
	showClock: true,
	title: '',
	symbol: null,
	headerRightSectionItems: [],
	headerLeftSectionItems: []
};

export const HEADER_EVENTS = {
	CONFIGURATION: 'header.configuration',
	ACTION: 'header.action'
} as const;
